var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditedHistory(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clock-history",
    transform: "translate(0.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_68477",
    "data-name": "Path 68477",
    d: "M8.386.764Q8.193.75,8,.75V0q.221,0,.442.016L8.386.764Zm1.5.337A5.252,5.252,0,0,0,9.15.877L9.315.145A5.923,5.923,0,0,1,10.159.4l-.27.7Zm1.027.532q-.161-.107-.329-.2l.37-.652a6.018,6.018,0,0,1,.734.49l-.461.592q-.153-.119-.313-.226Zm1.375,1.342a5.242,5.242,0,0,0-.49-.6l.543-.517a6.257,6.257,0,0,1,.56.682ZM12.85,3.99q-.074-.178-.16-.351l.67-.337a5.981,5.981,0,0,1,.337.816l-.712.235q-.06-.184-.134-.362Zm.4,1.88a5.243,5.243,0,0,0-.075-.769l.739-.127A6.037,6.037,0,0,1,14,5.852l-.75.019Zm-.1,1.153c.025-.127.045-.254.061-.382l.745.092a5.967,5.967,0,0,1-.172.866l-.723-.2q.052-.186.09-.376Zm-.714,1.784a5.3,5.3,0,0,0,.364-.681l.685.3a6.053,6.053,0,0,1-.416.778l-.634-.4Zm-.723.9q.137-.137.262-.283l.568.49q-.144.167-.3.324l-.53-.53Z",
    transform: "translate(-2.002)",
    fill: "#586973"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68478",
    "data-name": "Path 68478",
    d: "M6,.75A5.249,5.249,0,1,0,9.71,9.711l.53.53A6,6,0,1,1,6,0Z",
    transform: "translate(0 0)",
    fill: "#586973"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68479",
    "data-name": "Path 68479",
    d: "M7.375,3a.375.375,0,0,1,.375.375V7.282l2.436,1.392a.375.375,0,0,1-.372.651l-2.625-1.5A.375.375,0,0,1,7,7.5V3.375A.375.375,0,0,1,7.375,3Z",
    transform: "translate(-1.752 -0.75)",
    fill: "#586973"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditedHistory);
export default __webpack_public_path__ + "static/media/edited-history.70ee66f8.svg";
export { ForwardRef as ReactComponent };